import React from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {BanTypeEnum} from '../../Constants/banTypeEnum';
import {scheduledDate, formatAmount} from '../../utils/banTypeClassifier';
import BitPendingLabel from '../BitPendingLabel';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';
import BanPaymentMethodRow from './BanPaymentMethodRow';

const scheduledDebtAmountDisplay = (raw) => {
  if (raw === undefined || raw === null || raw === '') {
    return '';
  }
  const num = typeof raw === 'number' ? raw : parseFloat(String(raw).trim().replace(/,/g, ''));
  if (Number.isNaN(num)) {
    return String(raw);
  }
  const magnitude = Math.abs(num);
  const formatted = formatAmount(magnitude);
  if (!formatted) return String(raw);
  if (num < 0) {
    return `₪-${formatted}`;
  }
  return `₪${formatted}`;
};

const ScheduledPaymentBanStatus = ({banData, onActionClick}) => {
  const getDebtAmount = () => {
    if (banData.banType === BanTypeEnum.BAN_WITH_FUTURE_INVOICE) {
      return banData.totalDueAmount;
    }
    if (banData.banType === BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING) {
      if (banData.arBalance > 0) {
        return banData.arBalance;
      }
      return banData.totalDueAmount;
    }
  };

  const isShowPaymentButton = () => {
    if (banData.banType === BanTypeEnum.BAN_WITH_FUTURE_INVOICE) {
      return parseFloat(banData.totalDueAmount) > 0;
    }
    if (banData.banType === BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING) {
      return parseFloat(banData.arBalance) > 0 || parseFloat(banData.totalDueAmount) > 0;
    }
    return false;
  };

  return (
    <div className={`scheduled-payment-ban-status`}>
      <BanPaymentMethodRow banData={banData} />
      <div className='ban-status-card__section-divider' />
      <div className='scheduled-payment-ban-status__content'>
        <div className='scheduled-payment-ban-status__info'>
          {banData.payPendingStatus && <BitPendingLabel />}
          <div dangerouslySetInnerHTML={{__html: scheduledDate(banData)}} className='scheduled-payment-ban-status__debt-label' />
          <div dir='ltr' className='scheduled-payment-ban-status__debt-amount__future'>
            {scheduledDebtAmountDisplay(getDebtAmount())}
          </div>

          <div className='payment-issue-ban-status__action-links'>
            {banData.banType === BanTypeEnum.BAN_WITH_FUTURE_INVOICE && banData.invoiceUrl && (
              <button type='button' className='link' onClick={() => buildUrlAndOpenWindow(banData.invoiceUrl)}>
                לצפייה בחשבונית
              </button>
            )}
            {!isShowPaymentButton() ? null : (
              <button type='button' className='link' onClick={onActionClick}>
                לתשלום מראש
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduledPaymentBanStatus;
